/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _equalHeight = __webpack_require__(1);

	var _equalHeight2 = _interopRequireDefault(_equalHeight);

	var _dateIphoneFix = __webpack_require__(3);

	var _dateIphoneFix2 = _interopRequireDefault(_dateIphoneFix);

	var _jsFormValidate = __webpack_require__(4);

	var _jsFormValidate2 = _interopRequireDefault(_jsFormValidate);

	var _lightbox = __webpack_require__(5);

	var _lightbox2 = _interopRequireDefault(_lightbox);

	var _masonaryGrid = __webpack_require__(6);

	var _masonaryGrid2 = _interopRequireDefault(_masonaryGrid);

	var _menu = __webpack_require__(7);

	var _menu2 = _interopRequireDefault(_menu);

	var _messages = __webpack_require__(8);

	var _messages2 = _interopRequireDefault(_messages);

	var _readMoreLess = __webpack_require__(9);

	var _readMoreLess2 = _interopRequireDefault(_readMoreLess);

	var _reposition = __webpack_require__(10);

	var _reposition2 = _interopRequireDefault(_reposition);

	var _search = __webpack_require__(11);

	var _search2 = _interopRequireDefault(_search);

	var _select = __webpack_require__(12);

	var _select2 = _interopRequireDefault(_select);

	var _sliders = __webpack_require__(13);

	var _sliders2 = _interopRequireDefault(_sliders);

	var _stickyHeader = __webpack_require__(14);

	var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

	var _tabs = __webpack_require__(15);

	var _tabs2 = _interopRequireDefault(_tabs);

	var _textareaWordLimiter = __webpack_require__(16);

	var _textareaWordLimiter2 = _interopRequireDefault(_textareaWordLimiter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	jQuery(function () {
		//Masonary Grid
		_masonaryGrid2.default.init();

		// Site Menu
		_menu2.default.init();

		// Equal Height
		_equalHeight2.default.init();

		// Slick Slider
		_sliders2.default.init();

		// Textarea Word Limiter
		_textareaWordLimiter2.default.init();

		// Tabs
		_tabs2.default.init();

		// Read more/less toggler
		_readMoreLess2.default.init();

		// Reposition elements
		_reposition2.default.init();

		// Search
		_search2.default.init();

		// Sticky header
		_stickyHeader2.default.init();

		// Frontend form validation
		_jsFormValidate2.default.init();

		//Messages
		_messages2.default.init();

		// Select 2
		_select2.default.init();

		// Lightbox
		_lightbox2.default.init();

		// Date Iphone Fix
		_dateIphoneFix2.default.init();

		$(document).ajaxComplete(function () {
			//Select2 
			_select2.default.init();

			//Masonary Grid
			_masonaryGrid2.default.init();

			// Date Iphone Fix
			_dateIphoneFix2.default.init();
		});
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var EqualHeight = {

	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    var whoAreWeDescription = $('.view-content').find('.e-btn');

	    if ($('body').hasClass('page-who-we-are') && $('.views-element-container').find('.e-btn').length) {

	      var highestBox = 0;

	      $(whoAreWeDescription).each(function () {
	        if ($(this).siblings('.field-field_title').height() > highestBox) {
	          highestBox = $(this).siblings('.field-field_title').height();
	        }
	      });

	      $(whoAreWeDescription).siblings('.field-field_title').height(highestBox);
	    }
	  }
	};

	exports.default = EqualHeight;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Global = {
		$domWindow: $(window),
		$domDoc: $(document),
		$domBody: $('body'),

		varsWindowWidth: window.innerWidth,

		functions: {
			escKey: function escKey(callback) {
				Global.$domDoc.on('keyup', function (e) {
					if (e.keyCode === 27) {
						callback();
					}
				});
			},

			clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
				selector.on('mouseup', function (e) {
					e.preventDefault();
					if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
						callback();
					}
				});
			}
		}
	};

	exports.default = Global;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	       value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var DateIphoneFix = {
	       init: function init() {
	              var $dateField = $('form.submit-your-photo-form').find('input.form-date');

	              $dateField.datepicker({
	                     dateFormat: 'yy-mm-dd'
	              });
	       }
	};

	exports.default = DateIphoneFix;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var FormValidate = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		// Use this class for every form you whant to validate
		classForm: '.js-validation',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			if ($(FormValidate.classForm).length > 0) {
				$.validate({
					form: FormValidate.classForm
				});
			}

			$(document).ready(function () {
				$('.submit-your-photo-form #edit-form-submit').click(function () {
					$('.error-message').remove();
					var allChecked = true;

					$('.submit-your-photo-form input[required="required"]').each(function () {
						if (!$(this).is(':checked')) {
							allChecked = false;
							$(this).closest('.submit-your-photo-form .js-form-type-checkbox').append('<p class="error-message">This checkbox is required.</p>');
						}
					});
				});
			});
		}
	};

	exports.default = FormValidate;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Lightbox = {
	    init: function init() {
	        var $domLightboxUrl = $('.slick-track .views-row a');

	        $domLightboxUrl.each(function (index, el) {
	            var $this = $(el);
	            $this.on('click', function () {
	                setTimeout(function () {
	                    var authorName = $this.data('author');
	                    var $domLbCaption = $('.lb-caption');
	                    $domLbCaption.html($domLbCaption.html() + ', ' + authorName);
	                }, 1000);
	            });
	        });
	    }
	};

	exports.default = Lightbox;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var MasonaryGrid = {
	    /*-------------------------------------------------------------------------------
	    # Initialize
	    -------------------------------------------------------------------------------*/
	    init: function init() {
	        if ($('body').hasClass('page-image-repository') || $('body').hasClass('page-image-repository-tag-filtered')) {
	            // @TODO - Remove next commented line after testing.
	            // let popularTags = $('.popular-tag').once();
	            var popularTags = $(once('test-id', '.popular-tag'));
	            var selectInput = $('.view-filters').find('.form-select');
	            var applyButton = $('[id*="edit-submit-image-repository"]');
	            // @TODO - Remove next commented line after testing.
	            // let option = $('[id*="edit-field-marked-category"]').find('.option');
	            var option = $(once('test-id', '[id*="edit-field-marked-category"]'));
	            var searchMediaInput = $('.media-library-dummy-searchbar').find('input');
	            var searchButton = $('.media-library-dummy-searchbar').find('button');
	            var searchMediaHidden = $('.view-filters').find('.form-item-search-api-fulltext').find('input');

	            var elem = document.querySelector('.view-content');
	            var msnry = new Masonry(elem, {
	                // options
	                itemSelector: '.views-row',
	                columnWidth: '.views-row',
	                gutter: 30
	            });

	            searchMediaInput.val(searchMediaHidden.val());

	            //Set value on ajax complete
	            searchButton.on('click', function () {
	                searchMediaHidden.val(searchMediaInput.val());
	                searchMediaHidden.trigger('change');
	                applyButton.trigger('click');
	            });

	            searchMediaInput.on('keypress', function (e) {
	                if (e.key === "Enter") {
	                    searchMediaHidden.val(searchMediaInput.val());
	                    searchMediaHidden.trigger('change');
	                    applyButton.trigger('click');
	                }
	            });

	            if (searchMediaInput.length > 0) {
	                $(searchMediaInput).on('keyup', function (e) {
	                    $(e.target).addClass('keyuped');
	                });
	            }

	            // @TODO - Remove next commented line after testing.
	            // popularTags.once().on('click', (e) => {
	            popularTags.on('click', function (e) {
	                e.preventDefault();
	                var $this = $(e.target);
	                var selectValue = $this.text();
	                var option = selectInput.find('option');

	                option.each(function (index, el) {
	                    var optionVal = $(el).text();

	                    if (selectValue === optionVal) {
	                        $(el).attr('selected', 'selected');
	                        selectInput.trigger('change');
	                        applyButton.trigger('click');
	                        // @TODO - Remove next commented line after testing.
	                        //  triggerTagDropDown();
	                    }
	                });
	            });

	            // @TODO - Remove next commented line after testing.
	            // option.once().on('click', (e) => {
	            option.on('click', function (e) {
	                var inputState = $(e.target).siblings('input').prop('checked');
	                var input = $(e.target).siblings('input');

	                if (inputState === false) {
	                    input.prop('checked', true);
	                } else {
	                    input.prop('checked', false);
	                }
	                applyButton.trigger('click');
	            });
	        }
	    }
	};

	exports.default = MasonaryGrid;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Menu = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domMenuBtn: $('.js-menu-btn'),
		$domMenuNav: $('.js-main-nav'),
		$domMenuHasSub: $('.js-main-nav .menu-item--expanded'),
		classOpen: 'open',
		classOpenMenu: 'menu-open',
		classSubMenu: '.menu-item--expanded > .menu',
		classSubIcon: '.sub-icon',
		classMenu: '.menu',
		classList: 'li',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// Body transition on load
			_global2.default.$domBody.addClass('visible');

			// functions
			var closeNav = function closeNav() {
				Menu.$domMenuBtn.removeClass(Menu.classOpen);
				Menu.$domMenuNav.removeClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass(Menu.classOpen);
				_global2.default.$domBody.removeClass(Menu.classOpenMenu);
			};

			if (_global2.default.varsWindowWidth < 1200) {
				Menu.$domMenuHasSub.each(function (i, el) {
					$(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
				});
			}

			// bind events
			Menu.$domMenuBtn.on('click', function (e) {
				e.preventDefault();
				Menu.$domMenuBtn.toggleClass(Menu.classOpen);
				Menu.$domMenuNav.toggleClass(Menu.classOpen).find(Menu.classSubMenu).slideUp();
				Menu.$domMenuNav.find(Menu.classSubIcon).removeClass('open');
				_global2.default.$domBody.toggleClass(Menu.classOpenMenu);
			});

			Menu.$domMenuNav.on('click', '[data-open-sub]', function (e) {
				var self = $(e.currentTarget);

				if (self.hasClass(Menu.classOpen)) {
					self.removeClass(Menu.classOpen).siblings(Menu.classSubMenu).slideUp();
					self.siblings().find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.siblings().find(Menu.classMenu).slideUp();
				} else {
					self.addClass(Menu.classOpen).siblings(Menu.classSubMenu).slideDown();
					self.parent().siblings(Menu.classList).find(Menu.classSubIcon).removeClass(Menu.classOpen);
					self.parent().siblings(Menu.classList).find(Menu.classMenu).slideUp();
				}
			});

			_global2.default.functions.clickOutsideContainer(Menu.$domMenuNav, Menu.$domMenuNav.find('ul'), Menu.$domMenuBtn, closeNav);

			_global2.default.functions.escKey(closeNav);
		}
	};

	exports.default = Menu;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();
	// import jQuery from "jquery";

	'use strict'; // jshint ignore:line

	var Messages = {

	  init: function init() {

	    $(document).ready(function () {
	      $('div[role="contentinfo"]').append('<div class="close-button"></div>');

	      function closeFlashMessages() {
	        $('body').find('div[role="contentinfo"] .close-button').on('click', function (e) {
	          $('div[role="contentinfo"]').addClass('hide');
	        });
	      }

	      closeFlashMessages();

	      $(document).ajaxComplete(function () {
	        closeFlashMessages();
	      });
	    });
	  }
	};

	exports.default = Messages;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var ReadMoreLess = {
	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    if ($('body').hasClass('page-photo-competition') && $('.view-mark-photo'.length) || $('body').hasClass('page-external-view') && $('.view-mark-photo'.length)) {
	      var truncate = function truncate(source, size) {
	        return source.length > size ? source.slice(0, size - 1) + "…" : source;
	      };

	      $('.node--type-photography-competition').each(function (i, el) {
	        $(el).find('.field-body').children('.field--item').addClass('body-text');

	        if ($(el).find('.field-body').children('.field--item').length) {
	          $(el).find('.field-body').children('.field--item').addClass('body-text');
	        } else {

	          if (!$(el).find('.field-body').children().length) {
	            $(el).find('.field-body').append('<div class="body-text"></div>');
	            $(el).find('.field-body').find('.body-text').text($(el).find('.field-body').text());

	            // remove only text
	            $(el).find('.field-body').contents().filter(function () {
	              return this.nodeType === 3;
	            }).remove();
	          } else {
	            $(el).find('.field-body').children().wrapAll('<div class="body-text">');
	          }
	        }

	        var originalText = $(el).find('.field-body').find('.body-text').text();
	        if ($(el).find('.field-body').find('.body-text').height() > 87) {
	          $(el).find('.field-body').addClass('content-hidden');
	          $(el).find('.field-body').append('<span class="expand read-more">Read more</span>');
	          $(el).find('.field-body').find('.body-text').text(truncate($(el).find('.field-body').find('.body-text').text(), 175));
	        }

	        $(el).find('.expand').on('click', function (e) {
	          var self = $(e.currentTarget);

	          if (self.hasClass('read-more')) {
	            self.removeClass('read-more').addClass('read-less');
	            self.html('Read less');
	            self.parent().removeClass('content-hidden');
	            self.parent().find('.body-text').text(originalText);
	          } else {
	            self.removeClass('read-less').addClass('read-more');
	            self.html('Read more');
	            self.parent().addClass('content-hidden');
	            self.parent().find('.body-text').text(truncate($(el).find('.field-body').find('.body-text').text(), 175));
	          }
	        });
	      });
	    }
	  }
	};

	exports.default = ReadMoreLess;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Reposition = {
		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			if ($('ul.slick-dots').length) {
				$('.slick-dots').wrap('<div class="container slick-dots-wrapper"></div>');
			}

			if (_global2.default.varsWindowWidth < 1200) {
				$('#block-searchblock').detach().insertBefore('#block-seafarers-trust-main-menu ul.menu > li:first-of-type');
			}

			// News and press release single
			if ($('body').hasClass('page-node-news') || $('body').hasClass('page-node-press_release')) {
				$('.node-created-date').detach().insertAfter('h1');
				$('.node-type-label').detach().insertAfter('h1');
			}

			if ($('body').hasClass('page-node-press_release')) {
				$('.field-field_immediate_release').detach().insertBefore('.node-created-date');
			}

			// How to apply 4 block wrap
			if ($('#block-howtoapply').length) {
				$('.c-prefooter').find('.col-sm-12').children('div').children('div[id]').not(':last-of-type').wrapAll('<div class="block-wrapper"></div>');
			}

			if ($('#block-howtoapplyforcovid19welfarefund').length) {
				$('.c-prefooter').find('.col-sm-12').children('div').children('div[id]').not(':last-of-type').wrapAll('<div class="block-wrapper"></div>');
			}

			if ($('#block-howtoapplystef').length) {
				$('.c-prefooter').find('.col-sm-12').children('div').children('div[id]').not(':last-of-type').wrapAll('<div class="block-wrapper"></div>');
			}

			// Photo competition submission form
			if ($('form[id*="submit-your-photo-form"]').length) {
				var labelRename = function labelRename() {
					$('div[class*="-field-permission"]').each(function (i, el) {
						$(el).find('label').addClass('primary-label').html('Please Tick');
						$(el).prepend('<div class="secondary-label">' + labelText + '</div>');
					});
				};

				$('body').addClass('page-submission-form');
				var labelText = $('div[class*="-field-permission"]').find('label').html();

				labelRename();

				$(document).ajaxComplete(function () {
					labelRename();
				});
			}

			//Mark photo expand/collapse
			if ($('.view-mark-photo').length) {

				$('.view-mark-photo').find('article').each(function (i, el) {

					$(el).find('.field-unique-id, .field-field_title_of_your_photo').wrapAll('<div class="unique-id-title-wrapper"></div>');

					$(el).find('.photographer-details-wrapper').children('span').addClass('toggler').nextAll('.field').wrapAll('<div class="photo-info-expand"></div>');
					$(el).find('.subject-wrapper').children('span').addClass('toggler').nextAll('.field, .field-permission').wrapAll('<div class="photo-info-expand"></div>');

					$(el).find('.toggler').each(function (i, toggler) {

						$(toggler).on('click', function (e) {
							var self = $(e.currentTarget);
							self.toggleClass('active');
							self.siblings('.photo-info-expand').slideToggle();
						});
					});
				});
			}
		}
	};

	exports.default = Reposition;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Search = {
	  /*-------------------------------------------------------------------------------
	  # Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    if (_global2.default.varsWindowWidth > 1200) {
	      $('<i class="font-icon-search"></i>').insertBefore('form#search-form');
	      $('.font-icon-search').on('click', function (e) {

	        if ($('form#search-form').hasClass('visible')) {
	          $('form#search-form').removeClass('visible');
	          $('.dialog-off-canvas-main-canvas').removeClass('search-visible');
	        } else {
	          $('form#search-form').addClass('visible');
	          $('form#search-form').find('.form-item-keywords').find('input').focus();
	          $('.dialog-off-canvas-main-canvas').addClass('search-visible');

	          setTimeout(function () {
	            $(document).click(function (event) {
	              var $target = $(event.target);
	              if (!$target.closest('#site-navigation').length) {
	                $('form#search-form').removeClass("visible");
	                $('.dialog-off-canvas-main-canvas').removeClass('search-visible');
	              }
	            });
	          }, 600);
	        }
	      });
	    }

	    $('form#search-form').find('#edit-submit').attr('disabled', 'disabled');
	    $('form#search-form').find('.form-item-keywords').find('input').on('input', function (e) {
	      var data = $(e.currentTarget);

	      if (data.val().length > 0) {
	        $('form#search-form').find('#edit-submit').removeAttr('disabled');
	      } else {
	        $('form#search-form').find('#edit-submit').attr('disabled', 'disabled');
	      }
	    });
	  }
	};

	exports.default = Search;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Select2 = {
		/*-------------------------------------------------------------------------------
	 # Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// drupal fix for multilingual
			var selectPlaceholder = void 0;

			if ($('body').hasClass('page-node-photography_competition')) {
				//if on image repository single page
				selectPlaceholder = Drupal.t("Download");
			} else if ($('body').hasClass('page-image-repository')) {
				selectPlaceholder = Drupal.t("Please select");
			} else {
				//all other placeholders
				selectPlaceholder = Drupal.t("Select an option");
			}

			var $domSelect = $('select');

			$domSelect.select2({
				placeholder: '' + selectPlaceholder,
				allowClear: true
			});

			if ($('body').hasClass('page-image-repository-tag-filtered')) {
				$('select').select2({
					placeholder: {
						id: 'All',
						text: Drupal.t("Please select")
					}
				});
			}

			//image repository stop propagation on select
			$domSelect.on("select2:unselect", function (evt) {
				if (!evt.params.originalEvent) {
					return;
				}

				evt.params.originalEvent.stopPropagation();
			});

			//image repository single page download button trigger
			if ($('body').hasClass('page-node-photography_competition')) {
				$domSelect.on("select2:select", function () {
					var $domDownloadButton = $('#edit-submit');
					$domDownloadButton.click();
					setTimeout(function () {
						$domSelect.val('').trigger('change');
					}, 1);
				});
			}
		}
	};

	exports.default = Select2;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var Sliders = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$domSlider: $('.js-slider'),
		$domSliderBanner: $('.js-slider-banner'),
		$domFieldSliders: $('.field-field_slides'),
		$domLatestNews: $('#block-views-block-news-block-2').find('.view-news').find('.view-content'),
		$domImageRepository: $('#block-views-block-image-repository-slider-block-1').find('.view-image-repository-slider').find('.view-content'),

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {
			// slider
			Sliders.$domSlider.slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: false,
				dots: true,
				responsive: [{
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}]
			});

			// Banner Slider
			Sliders.$domSliderBanner.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: true,
				dots: true,
				pauseOnHover: false,
				pauseOnFocus: false,
				fade: true,
				autoplaySpeed: 4000
			});

			// Field sliders Slider
			Sliders.$domFieldSliders.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				arrows: false,
				autoplay: false,
				dots: true,
				pauseOnHover: false,
				pauseOnFocus: false,
				fade: true,
				autoplaySpeed: 4000
			});

			// Latest News Slider
			Sliders.$domLatestNews.slick({
				infinite: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				speed: 200,
				arrows: true,
				autoplay: false,
				dots: false,
				responsive: [{
					breakpoint: 991,
					settings: {
						slidesToShow: 2
					}
				}, {
					breakpoint: 767,
					settings: {
						slidesToShow: 1
					}
				}]
			});

			if (Sliders.$domImageRepository.length) {

				$('.view-image-repository-slider').append('<span class="slider-count">sliders bitch</span>');

				Sliders.$domImageRepository.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
					var i = (currentSlide ? currentSlide : 0) + 1;
					$('.slider-count').text('Image ' + i + '/' + slick.slideCount);
				});

				Sliders.$domImageRepository.slick({
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 1000,
					arrows: true,
					autoplay: false,
					pauseOnHover: false,
					pauseOnFocus: false,
					autoplaySpeed: 4000
				});
			}
		}
	};

	exports.default = Sliders;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Sticky = {
		/*-------------------------------------------------------------------------------
	 	# Cache dom and strings
	 -------------------------------------------------------------------------------*/
		$header: $('.js-header'),
		$content: $('.js-site-content'),
		classSticky: 'sticky-header',
		classStickyContent: 'sticky-content',

		/*-------------------------------------------------------------------------------
	 	# Initialize
	 -------------------------------------------------------------------------------*/
		init: function init() {

			$(window).on('scroll', function () {
				if ($(window).scrollTop() >= 30) {
					Sticky.$content.addClass(Sticky.classStickyContent);
					Sticky.$header.addClass(Sticky.classSticky);
				} else {
					Sticky.$content.removeClass(Sticky.classStickyContent);
					Sticky.$header.removeClass(Sticky.classSticky);
				}
			});
		}
	};

	exports.default = Sticky;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();


	'use strict'; // jshint ignore:line
	var Tabs = {

	  /*-------------------------------------------------------------------------------
	  	# Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {

	    if ($('.tabs-page').length) {

	      $('.tab-link').first().addClass('tab-link__active');
	      $('.tab-content').first().addClass('tab-content__active');

	      $('.tab').find('.tab-link').each(function () {
	        var currentTarget = $(this);

	        currentTarget.on('click', function (e) {
	          e.preventDefault();
	          var currentTargetPath = currentTarget.attr('href').substring(1);

	          if (!$(currentTarget).hasClass('tab-link__active')) {
	            $('.tab').find('.tab-link').removeClass('tab-link__active');
	            $('.tab-content').removeClass('tab-content__active');
	            $('div[id^=' + currentTargetPath + ']').addClass('tab-content__active');
	            currentTarget.addClass('tab-link__active');
	          }
	        });
	      });

	      $('.tab').prepend('<div class="tab-title"></div>');
	      $('div[id*="block-seafarers-trust-content"]').find('.field-body').children('p').last().detach().appendTo('.tab-title');
	    }
	  }
	};

	exports.default = Tabs;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _global = __webpack_require__(2);

	var _global2 = _interopRequireDefault(_global);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var $ = jQuery.noConflict();

	'use strict'; // jshint ignore:line
	var TextareaWordLimiter = {
	  /*-------------------------------------------------------------------------------
	  	# Initialize
	  -------------------------------------------------------------------------------*/
	  init: function init() {
	    if ($('form[id*="submit-your-photo-form"]').length) {
	      var textareaLimiter = function textareaLimiter() {
	        $('textarea[id*="edit-form-photo-info-"]').each(function (i, el) {
	          $(el).on('keyup', function () {
	            var words = 0;

	            if (this.value.match(/\S+/g) != null) {
	              words = this.value.match(/\S+/g).length;
	            }

	            if (words > 500) {
	              var trimmed = $(this).val().split(/\s+/, 500).join(" ");
	              $(this).val(trimmed + " ");
	            }
	          });
	        });

	        $('input[type="date"]').each(function (i, el) {
	          $(el).attr('type', 'text');
	          $(el).attr('data-date-format', 'DD MMMM YYYY');

	          $(el).on("focusin", function () {
	            $(el).attr('type', 'date');
	          });

	          $(el).on("focusout", function () {

	            if ($(el).val() === '') {
	              $(el).attr('type', 'text');
	              $(el).attr('data-date-format', 'DD MMMM YYYY');
	            } else {
	              $(el).attr('type', 'date');
	            }
	          });
	        });
	      };

	      textareaLimiter();

	      $(document).ajaxComplete(function () {
	        textareaLimiter();
	      });
	    }
	  }
	};

	exports.default = TextareaWordLimiter;

/***/ })
/******/ ]);